import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const erasmusQuestionnaireApi = createApi({
  reducerPath: 'erasmusQuestionnaireApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getErasmusQuestionnaires: builder.query({
      query: (isEnglish = false) => {
        return {
          url: urls.erasmusQuestionnaire,
        };
      },
    }),
    getErasmusQuestionnaire: builder.query({
      query: (id) => ({
        url: urls.erasmusQuestionnaireDetail(id),
      }),
    }),
    saveErasmusQuestionnaire: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.erasmusQuestionnaireDetail(req.id),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: urls.erasmusQuestionnaire,
            method: 'POST',
            data: req.body,
          };
        }
      },
    }),
    deleteErasmusQuestionnaire: builder.mutation({
      query(id) {
        return {
          url: urls.erasmusQuestionnaireDetail(id),
          method: 'DELETE',
        };
      },
    }),
    getErasmusQuestionnaireByMobilityId: builder.query({
      query: (mobility_id) => ({
        url: urls.erasmusQuestionnaireByMobilityId(mobility_id),
      }),
    }),
  }),
});

export const {
  useGetErasmusQuestionnairesQuery,
  useGetErasmusQuestionnaireQuery,
  useSaveErasmusQuestionnaireMutation,
  useDeleteErasmusQuestionnaireMutation,
  useGetErasmusQuestionnaireByMobilityIdQuery,
} = erasmusQuestionnaireApi;
